/*
 * @Author: zhaozhuo
 * @Date: 2022-02-17 10:13:59
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-03-02 17:27:41
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\center.js
 */
import { get } from '../axios'
const center = {
	// 获取中心列表
	getCenterList: params => get(`/web/center/getAscriptionCenterList/${params}`)
}
export default center